"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIMENSION_XXL = exports.DIMENSION_XS = exports.DIMENSION_XL = exports.DIMENSION_SM = exports.DIMENSION_MD = exports.DIMENSION_LG = void 0;
exports.default = useResponsiveDimension;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var _useWindowSize2 = _interopRequireDefault(require("./useWindowSize"));

var DIMENSION_XS = 'xs';
exports.DIMENSION_XS = DIMENSION_XS;
var DIMENSION_SM = 'sm';
exports.DIMENSION_SM = DIMENSION_SM;
var DIMENSION_MD = 'md';
exports.DIMENSION_MD = DIMENSION_MD;
var DIMENSION_LG = 'lg';
exports.DIMENSION_LG = DIMENSION_LG;
var DIMENSION_XL = 'xl';
exports.DIMENSION_XL = DIMENSION_XL;
var DIMENSION_XXL = 'xxl';
/**
 * Returns the responsive dimension of the screen.
 * Follows antd Grid dimensions
 * @returns {string}
 */

exports.DIMENSION_XXL = DIMENSION_XXL;

function useResponsiveDimension() {
  var _useWindowSize = (0, _useWindowSize2.default)(),
      width = _useWindowSize.width;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      dim = _useState2[0],
      setDim = _useState2[1];

  (0, _react.useEffect)(function () {
    var d = null;

    if (width < 576) {
      d = DIMENSION_XS;
    } else if (width < 768) {
      d = DIMENSION_SM;
    } else if (width < 992) {
      d = DIMENSION_MD;
    } else if (width < 1200) {
      d = DIMENSION_LG;
    } else if (width < 1600) {
      d = DIMENSION_XL;
    } else {
      d = DIMENSION_XXL;
    }

    if (dim !== d) {
      setDim(d);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [width]);
  return dim;
}